export enum TypeValeurEnum {
  ENTIER = 'Entier',
  DECIMAL = 'Décimal',
  POURCENTAGE = 'Pourcentage'
}
